<template>
  <div>
    <!-- #Início# Filtro de busca -->
    <div class="row" v-if="id_role != 3 && id_role != 4">
      <!-- Data de Atualizar Turmas -->
      <div class="col-md-6" @keyup.enter="atualizarTurmas">
        <DateIconGroup idInput="data" iconInput="fa-calendar" labelInput="Data">(AAAA-MM-DD)</DateIconGroup>
      </div>

      <!-- Atualizar Turmas -->
      <div class="col-md-6">
        <button :disabled="table.load" class="btn btn-block btn-micro btn-primary" id="btn" type="button"
          @click="atualizarTurmas">
          Atualizar Turmas
        </button>
      </div>

      <!-- Separador -->
      <div class="col-md-12">
        <hr>
      </div>

      <!-- Id Turma -->
      <!-- <div class="col-md-3" @keyup.enter="$refs.agrupamento.$el.children[0].children[0].focus()">
        <InputIconGroup iconInput="fa-list-ol" ref="id_turma" idInput="id_turma" labelInput="ID Turma"></InputIconGroup>
      </div> -->

      <!-- Agrupamento -->
      <div class="col-md-3" @keyup.enter="$refs.datainicial.$el.children[0].children[0].focus()">
        <InputIconGroup iconInput="fa-list-ol" idInput="id_agrupamento" ref="agrupamento" labelInput="ID Agrupamento">
        </InputIconGroup>
      </div>

      <!-- Data Início -->
      <div class="col-md-3" @keyup.enter="$refs.datafinal.$el.children[0].children[0].focus()">
        <DateIconGroup idInput="data_inicio" ref="datainicial" iconInput="fa-calendar" labelInput="Data Inicial">
          (AAAA-MM-DD)</DateIconGroup>
      </div>

      <!-- Data Fim -->
      <div class="col-md-3" @keyup.enter="$refs.alunosregulares.$el.children[0].children[0].focus()">
        <DateIconGroup idInput="data_fim" ref="datafinal" iconInput="fa-calendar" labelInput="Data Fim">(AAAA-MM-DD)
        </DateIconGroup>
      </div>

      <!-- Alunos Regulares (quantidade_alunos) -->
      <!-- <div class="col-md-3">
        <SelectIconGroup iconInput="fa-file" labelInput="Alunos Regulares" ref="alunosregulares"
          idInput="alunos_regulares" :optionsInput="optionsAlunosRegulares" :optionSelected="getAlunosRegulares">
        </SelectIconGroup>
      </div> -->

      <!-- Alunos para Reposição (quantidade_alunos_reposicao) Se for vazia ou nao -->
      <!--div class="col-md-3">
				<SelectIconGroup iconInput="fa-file" labelInput="Alunos Reposição" idInput="alunos_reposicao" :optionsInput="optionsAlunosReposicao" :optionSelected="getAlunosReposicao">
				</SelectIconGroup>
			</div-->

      <!-- Virtual (Sim ou Não) -->
      <div class="col-md-3">
        <SelectIconGroup iconInput="fa-file" labelInput="Tipo de aula" idInput="turma_virtual"
          :optionsInput="optionsTurmaVirtual" :optionSelected="getTurmaVirtual">
        </SelectIconGroup>
      </div>

      <!-- Status -->
      <div class="col-md-3">
        <SelectIconGroup iconInput="fa-file" labelInput="Status" idInput="turma_status"
          :optionsInput="optionsTurmaStatus" :optionSelected="getTurmaStatus">
        </SelectIconGroup>
      </div>

      <!-- Buscar -->
      <div class="col-md-3">
        <button :disabled="table.load" class="btn btn-micro btn-block btn-info" @click="getTurmas()">
          <i id="consultButton" class="fa fa-search pr-3 icon-branco"></i>
          <span class="font-button-modified">Consultar</span>
        </button>
      </div>

      <i alt="Download PDF" @click="download('pdf')" id="downloadButton" class="fa fa-file-pdf-o" v-if="!btnDownload">
          <span class="tooltiptext">Download PDF</span>&nbsp;&nbsp;
      </i>
      <i alt="Download PDF" id="downloadButton" class="fa fa-file-pdf-o" v-else>
          <span class="tooltiptext">Download PDF</span>&nbsp;&nbsp;
      </i>
      <i @click="download('xlsx')" id="downloadButton" class="fa fa-file-excel-o" v-if="!btnDownload">
          <span class="tooltiptext">Download XLSX</span>&nbsp;&nbsp;
      </i>
      <i id="downloadButton" class="fa fa-file-excel-o" v-else>
          <span class="tooltiptext">Download XLSX</span>&nbsp;&nbsp;
      </i>

      <br><br>
    </div>
    <!-- #Fim# Filtro de busca -->

    <!-- #Início# Botões da paginação-->
    <div class="row" v-show="table.data.length > 0 && !table.load">
      <div class="col mx-auto">
        <pagination :source="pagination" @navigate="navigate" class="pagination justify-content-center"></pagination>
      </div>
    </div>
    <!-- #Fim# Botões da paginação-->

    <!-- #Início# Tabela-->
    <div class="row" v-if="consulted || id_role == 3">
      <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
        <table class="table table-striped table-bordered table-responsive-sm text-center">
          <thead>
            <tr>
              <th v-for="th in tableOptions.thead" scope="col" :key="th.id">{{ th }}</th>
            </tr>
            <tr v-show="table.load">
              <td colspan="8" class="text-center">
                <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
                  <div class="btn-toolbar d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                    <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80">
                    </component>
                  </div>
                </div>
              </td>
            </tr>
          </thead>
          <tbody v-show="!table.load">
            <tr v-if="(id_role != '4' && id_role != '3') || !dados.cancelada" v-for="dados in table.data" :key="dados.id_turma_teorica">
              <td v-if="!isMobile">{{ dados.id_agrupamento }}</td>
              <td>{{ utils.formatDate(dados.data_inicio) }}</td>
              <td>{{ utils.formatDate(dados.data_fim) }}</td>
              <td v-if="!isMobile && id_role != 3 && id_role != 4">
                {{ dados.quantidade_alunos }}
              </td>
              <td v-if="!isMobile && id_role != 3 && id_role != 4">
                {{ dados.alunos_reposicao }}
              </td>
              <td v-if="!isMobile && id_role != 3 && id_role != 4">
                <span v-show="dados.virtual">SIM</span>
                <span v-show="!dados.virtual">NÃO</span>
              </td>
              <td v-if="!isMobile && id_role != 3 && id_role != 4">{{ dados.status }}</td>

              <td v-if="id_role != 3 && id_role != 4" class="buttons-td">
                <button title="Ver informações da turma" class="action-button" @click="detalhes(dados.id_turma_teorica)">
                  <i class="fa fa-info"></i>
                </button>
                <!-- <button title="Atualizar turma" class="btn btn-primary btn-with-icon rounded-icon btn-micro" :disabled="dados.flg_ativo" @click="paginaEdicao(dados.id_turma_teorica)">
									<span aria-hidden="true" class="fa fa-edit" style="font-size: 20px;padding-left: 5px;"></span>
								</button>
								<button title="Adicionar aula" class="btn btn-primary btn-with-icon rounded-icon btn-micro" :disabled="dados.flg_ativo" @click="paginaAula(dados.id_turma_teorica)">
									<span aria-hidden="true" class="fa fa-plus" style="font-size: 20px;padding-left: 3px;"></span>
								</button>
								<button title="Informar Biometria" class="btn btn-primary btn-with-icon rounded-icon btn-micro" :disabled="dados.flg_ativo" @click="biometria(dados.id_turma_teorica)">
									<span aria-hidden="true" class="fa fa-plus" style="font-size: 20px;padding-left: 3px;"></span>
								</button>
								<button title="Informar Faces" class="btn btn-primary btn-with-icon rounded-icon btn-micro" :disabled="dados.flg_ativo" @click="faces(dados.id_turma_teorica)">
									<span aria-hidden="true" class="fa fa-plus" style="font-size: 20px;padding-left: 3px;"></span>
								</button> -->
              </td>
              <td v-else-if="id_role == 3" class="buttons-td">
                <button :id="'push_' + dados.id_agrupamento" v-if="getTime(dados.data_fim)" title="Registre sua presença primeiro!" class="action-button" disabled="true" @click="push(dados)">
                  <i class="fa fa-video-camera"></i>
                </button>

                <button :id="'presenca_' + dados.id_agrupamento" title="Registrar Presença" class="action-button" @click="registrarPresenca(dados)" :disabled="loadingButton">
                  <i class="fa fa-user"></i>
                </button>

                <button title="Ver informações da turma" class="action-button" @click="detalhes(dados.id_turma_teorica)">
                  <i class="fa fa-info"></i>
                </button>
              </td>
              <td v-else class="buttons-td">
                <button :id="'push_' + dados.id_agrupamento" v-if="getTime(dados.data_fim)" title="Registre sua presença primeiro!" class="action-button" disabled="true" @click="push(dados)">
                  <i class="fa fa-video-camera"></i>
                </button>

                <button :id="'presenca_' + dados.id_agrupamento" title="Registrar Presença" class="action-button" @click="registrarPresenca(dados)" :disabled="loadingButton">
                  <i class="fa fa-user"></i>
                </button>
              </td>

              <!-- #Início# Modal de informações-->
              <vuestic-modal :show.sync="modal.show" :ref="'smallModal' + dados.id_turma_teorica" v-bind:small="false"
                :cancelClass="'none'" okText="Fechar" cancelText="Fechar" :large="true">
                <div slot="title">Informações</div>
                <div v-show="modal.load">
                  <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
                    <div class="btn-toolbar d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                      <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80">
                      </component>
                    </div>
                  </div>
                </div>
                <div v-show="!modal.load">
                  <vuestic-tabs @change="ativar($event)"
                    :names="['Dados Básicos', 'Alunos Regulares', 'Alunos Reposição', 'Aulas', 'Presenças', 'Feedback']"
                    ref="tabs">
                    <div slot="Dados Básicos">
                      <div class="row">
                        <div class="col-md-4">
                          <strong class="font-weight-bold">Agrupamento:</strong>
                          <p>{{ modal.conteudo.id_agrupamento }}</p>
                        </div>
                        <div class="col-md-4">
                          <strong class="font-weight-bold">Data de inicio:</strong>
                          <p>{{ utils.formatDate(modal.conteudo.data_inicio) }}</p>
                        </div>
                        <div class="col-md-4">
                          <strong class="font-weight-bold">Data de finalização:</strong>
                          <p>{{ utils.formatDate(modal.conteudo.data_fim) }}</p>
                        </div>
                      </div>
                      <br>
                      <div class="row" v-if="user == 'admin' && id_role == 1">
                        <div class="col-sm-6 text-center" v-if="dados.coleta_informada">
                          <hr>
                          <button class="btn btn-micro btn-info" :disabled='!btnGetStatus' type="button"
                            @click="getStatus(dados)">Atualizar Status</button>
                        </div>
                        <div class="col-sm-6 text-center" v-if="dados.coleta_informada && dados.virtual">
                          <hr>
                          <button class="btn btn-micro btn-danger" type="button"
                            @click="cancelarTurma(modal.conteudo.id_turma_teorica)">Cancelar Turma</button>
                        </div>

                        <!-- MUDANÇA TEMPORÁRIA (vv CÓDIGO ANTIGO vv)-->
                        <!-- <div class="col-sm-6 text-center" v-if="dados.coleta_informada && dados.virtual">
													<hr>
													<button class="btn btn-micro btn-info" :disabled='!btnSendTurma' type="button" @click="enviarBiometriaVirtual(dados)">Enviar Biometria</button>
												</div>
												<div class="col-sm-12 text-center">
													<hr>
													<button class="btn btn-micro btn-danger" type="button" @click="cancelarTurma(modal.conteudo.id_turma_teorica)">Cancelar Turma</button>
												</div> -->
                      </div>
                    </div>
                    <div slot="Alunos Regulares">
                      <div class="row">
                        <div class="col-md-12" v-if="regular === true">
                          <TableAlunosTurma :idTurma="dados.id_turma_teorica"></TableAlunosTurma>
                        </div>
                      </div>
                      <br>
                      <br>
                      <div class="row" v-if="id_role != 3">
                        <div class="col-md-12">
                          <button title="Adicionar Aluno" class="btn btn-primary btn-with-icon btn-micro"
                            @click="paginaEdicao(modal.conteudo.id_turma_teorica)">
                            <span aria-hidden="true" class="fa fa-plus"></span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div slot="Alunos Reposição">
                      <div class="row">
                        <div class="col-md-12" v-if="reposicao === true">
                          <TableAlunosReposicao :idTurma="dados.id_turma_teorica"></TableAlunosReposicao>
                        </div>
                      </div>
                    </div>
                    <div slot="Aulas">
                      <div class="row">
                        <div class="col-md-12" v-if="aula === true">
                          <TableAulasTurma :idTurma="dados.id_turma_teorica"></TableAulasTurma>
                        </div>
                      </div>
                    </div>
                    <div slot="Presenças">
                      <div class="row">
                        <div class="col-md-12" v-if="historico === true">
                          <TablePresencas :idTurma="dados.id_turma_teorica" :virtual="dados.virtual" :idRole="id_role">
                          </TablePresencas>
                        </div>
                      </div>
                    </div>
                    <div slot="Feedback">
                      <div class="row">
                        <div class="col-md-12" v-if="feedback === true">
                          <TableFeedbacks :idTurma="dados.id_turma_teorica"></TableFeedbacks>
                        </div>
                      </div>
                    </div>
                  </vuestic-tabs>
                </div>
              </vuestic-modal>
              <!-- #Fim# Modal de informações-->
            </tr>
            <tr v-show="table.data.length === 0 && !table.load">
              <td colspan="8" class="text-center">Nenhum registro encontrado.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- #Fim# Tabela-->

    <!-- #Início# Botões da paginação-->
    <div class="row" v-show="table.data.length > 0 && !table.load">
      <div class="col mx-auto">
        <pagination :source="pagination" @navigate="navigate" class="pagination justify-content-center"></pagination>
      </div>
    </div>
    <!-- #Fim# Botões da paginação-->

    <!-- #Início# Modal Tabela -->
    <!-- <div v-if="id_role == 3 || id_role == 4">
			<video id="webcam" autoplay playsinline width="640" height="480"></video>
			<canvas id="canvas" class="d-none"></canvas>
			<audio id="snapSound" src="audio/snap.wav" preload = "auto"></audio>
		</div> -->
    <vuestic-modal id="modal-photo" ref="photoModal" :cancelClass="'none'" :okClass="'none'" v-on:cancel="modalClosed">
      <div class="col-sm-12 col-lg-12 col-xl-12">
        <div class="row justify-content-center text-center">
          <h1>Registre sua presença!</h1>
          <div class="col-md-6">
            <!-- <img id="mask" height="250" width="250" src="~assets/mask.png" /> -->
            <video id="player" width="250" height="250" autoplay></video>
            <button @click="captureSnapshot" id="capture" class="btn btn-primary">Capturar</button>
          </div>
          <div class="col-md-6">
            <canvas id="snapshot" width="250" height="250"></canvas>
            <button @click="sendSnapshot" id="send" class="btn btn-primary" disabled>Enviar</button>
          </div>
        </div>
      </div>
    </vuestic-modal>
    <!-- #Fim# Modal Tabela -->
  </div>
</template>

<script>
import TurmasController from './TurmasController'
import * as spinners from 'epic-spinners'
import urlApi from '../../router/urlApi'
import TableAlunosTurma from './TableAlunosTurma'
import TableAlunosReposicao from './TableAlunosReposicao'
import TablePresencas from './TablePresencas'
import TableAulasTurma from './TableAulasTurma'
import InputIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/InputIconGroup'
import SelectIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/SelectIconGroup'
import { ModelSelect } from 'vue-search-select'
import DateIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/DateIconGroup'
import VuesticTabs from '@/vuestic-theme/vuestic-components/vuestic-tabs/VuesticTabs'
import utils from '../../services/utils'
import Webcam from 'webcam-easy'
import PresencaController from '../presenca/PresencaController'
import router from '../../router'
import TableFeedbacks from './TableFeedbacks'
import pagination from '../pagination/pagination'

window._ = require('lodash')

export default {
  name: 'TableTurmas',
  components: {
    ...spinners,
    TableAlunosTurma,
    DateIconGroup,
    TableAulasTurma,
    TablePresencas,
    TableAlunosReposicao,
    InputIconGroup,
    ModelSelect,
    SelectIconGroup,
    TableFeedbacks,
    pagination
  },
  data() {
    return {
      user: '',
      teste: false,
      btnSendTurma: true,
      btnGetStatus: true,
      id_role: localStorage.id_role,
      recarregar: false,
      feedback: false,
      modal: {
        show: false,
        load: false,
        conteudo: {}
      },
      url: urlApi + '/turmas/paginacao',
      tableOptions: {
        thead: ['Agrupamento', 'Início', 'Fim', 'Total de Alunos Regulares', 'Total de Alunos para Reposição', 'Virtual', 'Status', '-']
      },
      search: '',
      table: {
        currentPage: '',
        data: '',
        firstPageUrl: '',
        from: '',
        lastPage: '',
        lastPageUrl: '',
        nextPageUrl: '',
        path: '',
        perPage: '',
        prevPageUrl: '',
        to: '',
        total: '',
        pages: [],
        load: false
      },
      utils: utils,
      isMobile: false,
      stream: null,
      turma: '',
      'historico': false,
      'regular': false,
      'reposicao': false,
      'aula': false,
      optionsAlunosRegulares: [
        {
          id: 'null',
          value: 'Todos',
        },
        {
          id: '1',
          value: 'Sem alunos regulares',
        },
        {
          id: '2',
          value: 'Com alunos regulares',
        }
      ],
      getAlunosRegulares: '',
      optionsAlunosReposicao: [
        {
          id: 'null',
          value: 'Todos',
        },
        {
          id: '1',
          value: 'Sem alunos para reposição',
        },
        {
          id: '2',
          value: 'Com alunos para reposição',
        }
      ],
      getAlunosReposicao: '',
      optionsTurmaVirtual: [
        {
          id: 'null',
          value: 'Todos',
        },
        {
          id: '1',
          value: 'Virtual',
        },
        {
          id: '2',
          value: 'Presencial',
        }
      ],
      getTurmaVirtual: '',
      optionsTurmaStatus: [
        {
          id: 'null',
          value: 'Todos',
        },
        {
          id: '1',
          value: 'Pendente'
        },
        {
          id: '2',
          value: 'Confirmado',
        },
        {
          id: '3',
          value: 'Realizada',
        },
        {
          id: '4',
          value: 'Finalizada',
        },
        {
          id: '5',
          value: 'Cancelada'
        }
      ],
      getTurmaStatus: '',
      resultForm: [],
      resultsFilter: [],
      loadingButton: false,
      consulted: false,
      pagination: '',
      btnDownload: false
    }
  },
  created() {
    if (this.id_role == 3) {
      this.getTurmas()
    }
  },
  mounted() {
    if (localStorage.schema == 'teste') {
      this.teste = true
    }
    // this.loadData()
    if (window.innerWidth <= 800) {
      this.isMobile = true
      this.tableOptions.thead = ['Início', 'Fim', '-']
    }

    if (this.id_role == 3 || this.id_role == 4) {
      this.tableOptions.thead = ['Agrupamento', 'Início', 'Fim', '.', '-']
    }

    let email = localStorage.email.split('@')
    this.user = email[0]

    this.$refs.id_turma.$el.children[0].children[0].focus()
  },
  methods: {
    download(type) {
      if(!this.table.data.length) {
        TurmasController.launchToast( 'fa-times', 'Obrigatório realizar a consulta!', 'top-right')
        document.querySelector('#id_agrupamento').focus()
        return
      }
      this.btnDownload = true

      let url = this.table.path.split('/paginacao/')[1].split('/')
      let data = {
        id_turma: url[0],
        id_agrupamento: url[1],
        data_inicio: url[2],
        data_fim: url[3],
        alunos_regulares: url[4],
        turma_virtual: url[5],
        turma_status: url[6],
        type: type
      }
      var dlnk        =   document.createElement('a');
      let objectUrl   =   false;

      const queryString = Object.entries(data)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
      this.$http.get(`${process.env.VUE_APP_URL_API_V2}/aulas/teoricas/turmas/consultar/relatorio/agrupamentos?${queryString}`,
        type === 'xlsx' ? { responseType: 'blob' } : null)
        .then((response) => {
          if (type === 'xlsx') {
              return response.blob();
          }
          return response;
        })
        .then((response) => {
            switch (type) {
                case 'pdf':
                    TurmasController.launchToast( 'fa-times', response.body.message, 'top-right')
                    dlnk.download   =   "Agrupamentos.pdf";
                    dlnk.href       =   'data:application/octet-stream;base64,' + response.data.data;
                    break
                case 'xlsx':
                    TurmasController.launchToast( 'fa-times', 'Sucesso', 'top-right')
                    dlnk.download   =   "Agrupamentos.xlsx";
                    objectUrl = window.URL.createObjectURL(response)
                    dlnk.href = objectUrl;
                    break

                default:
                    this.$toasted.show('Tipo de arquivo não identificado', {
                        icon: 'fa-times',
                        position: 'top-right',
                        duration: 5000,
                        fullWidth: false
                    })
                    break
            }

            dlnk.click();
            objectUrl && window.URL.revokeObjectURL(objectUrl);
            dlnk.remove()
            this.btnDownload = false

        }).catch((error) => {
            this.btnDownload = false
            TurmasController.launchToast( 'fa-times', 'Não foi possível realizar a consulta!', 'top-right')
            document.querySelector('#id_agrupamento').focus()
            console.error(error)
      })
    },

    getTurmas() {
      if (this.id_role != 3 && !(document.querySelector('#id_agrupamento').value || (document.querySelector('#data_inicio').value || document.querySelector('#data_fim').value)) )
      {
        TurmasController.launchToast( 'fa-times', 'Obrigatório informar agrupamento ou periodo!', 'top-right')
        document.querySelector('#id_agrupamento').focus()
        return
      }
      this.consulted = true
      this.table.load = true
      var id_turma = document.querySelector('#id_turma') && document.querySelector('#id_turma').value ? document.querySelector('#id_turma').value : 'null'
      var id_agrupamento = document.querySelector('#id_agrupamento') && document.querySelector('#id_agrupamento').value ? document.querySelector('#id_agrupamento').value : 'null'
      var data_inicio = document.querySelector('#data_inicio') && document.querySelector('#data_inicio').value ? document.querySelector('#data_inicio').value : 'null'
      var data_fim = document.querySelector('#data_fim') && document.querySelector('#data_fim').value ? document.querySelector('#data_fim').value : 'null'
      var alunos_regulares = document.querySelector('#alunos_regulares') && document.querySelector('#alunos_regulares').value ? document.querySelector('#alunos_regulares').value : 'null'
      // var alunos_reposicao = document.querySelector("#alunos_reposicao") && document.querySelector("#alunos_reposicao").value ? document.querySelector("#alunos_reposicao").value : "null";
      var turma_virtual = document.querySelector('#turma_virtual') && document.querySelector('#turma_virtual').value ? document.querySelector('#turma_virtual').value : 'null'
      var turma_status = document.querySelector('#turma_status') && document.querySelector('#turma_status').value ? document.querySelector('#turma_status').value : 'null'

      var url = `${urlApi}/turmas/paginacao/${id_turma}/${id_agrupamento}/${data_inicio}/${data_fim}/${alunos_regulares}/${turma_virtual}/${turma_status}`
      this.cleanResultFilterRequisicao(url)
    },
    cleanResultFilterRequisicao(url) {
      this.table.data = ''
      this.table.from = ''
      this.table.currentPage = ''
      this.table.firstPageUrl = ''
      this.table.lastPage = ''
      this.table.lastPageUrl = ''
      this.table.nextPageUrl = ''
      this.table.path = ''
      this.table.perPage = ''
      this.table.prevPageUrl = ''
      this.table.to = ''
      this.table.total = ''
      this.table.pages = []
      this.table.resultForm = []
      this.table.resultsFilter = []

      this.$http.get(url).then((res) => {
        let responseData = res.data.dados

        this.table.data = responseData.turmas_teoricas.data
        this.table.from = responseData.turmas_teoricas.from

        this.table.currentPage = responseData.turmas_teoricas.current_page
        this.table.firstPageUrl = responseData.turmas_teoricas.first_page_url
        this.table.lastPage = responseData.turmas_teoricas.last_page
        this.table.lastPageUrl = responseData.turmas_teoricas.last_page_url
        this.table.nextPageUrl = responseData.turmas_teoricas.next_page_url
        this.table.path = responseData.turmas_teoricas.path
        this.table.perPage = responseData.turmas_teoricas.per_page
        this.table.prevPageUrl = responseData.turmas_teoricas.prev_page_url
        this.table.to = responseData.turmas_teoricas.to
        this.table.total = responseData.turmas_teoricas.total

        for (let i = 1; i <= (responseData.turmas_teoricas.last_page); i++) {
          this.table.pages.push(i)
        }

        this.items = this.table.data
        this.table.resultForm = responseData.filtros
        this.table.resultsFilter = responseData.turmas_teoricas.data
        this.table.data_atual = responseData.data_atual

        this.table.load = false
        this.pagination = responseData.turmas_teoricas
      })
    },
    navigate(page) {
        this.table.load = true
        this.cleanResultFilterRequisicao(`${this.table.path}?page=${page}`)
        // this.$http.get(`${this.table.path}?page=${page}`).then(this.cleanResultFilterRequisicao)
    },
    nextPage() {
      this.table.load = true
      var url = this.table.nextPageUrl
      this.cleanResultFilterRequisicao(url)
    },
    previousPage() {
      this.table.load = true
      var url = this.table.prevPageUrl
      this.cleanResultFilterRequisicao(url)
    },
    pagePaginates(page) {
      this.table.load = true
      var url = this.table.path + '?page=' + page
      this.cleanResultFilterRequisicao(url)
    },
    loadData() {
      this.table.load = true
      if (this.id_role == 4) {
        this.$http
          .get(this.url + '?search=' + this.search + '&aluno=' + localStorage.id)
          .then(this.callbackDataPaginate)
      } else if (this.id_role == 3) {
        this.$http
          .get(this.url + '?search=' + this.search + '&instrutor=' + localStorage.id)
          .then(this.callbackDataPaginate)
      } else {
        this.$http
          .get(this.url + '?search=' + this.search)
          .then(this.callbackDataPaginate)
      }
    },
    detalhes: function (idTurma) {
      let self = this
      this.statusModal = true
      this.$refs['smallModal' + idTurma][0].open()
      self.modal.load = true
      TurmasController.getTurmaById(idTurma, function (response) {
        self.modal.conteudo = response.data.dados
        self.modal.load = false
      })
    },
    getTime(data_fim) {
      let end = data_fim.split(/[- :]/)
      let end_date = new Date(new Date(end[0], end[1] - 1, end[2], end[3], end[4], end[5]))
      let check = ((end_date.getTime() - new Date().getTime()) > 0)
      return true
    },
    ead(turma) {
      var ini = turma.data_inicio.split(/[- :]/)
      var end = turma.data_fim.split(/[- :]/)

      var ini_date = new Date(new Date(ini[0], ini[1] - 1, ini[2], ini[3], ini[4], ini[5]))
      var end_date = new Date(new Date(end[0], end[1] - 1, end[2], end[3], end[4], end[5]))

      if (this.id_role == 3) {
        this.$router.push({
          name: 'eadAluno',
          params: {
            'ini': ini_date.getTime(),
            'end': end_date.getTime(),
            'turma': turma.id_turma_teorica
          }
        })
      } else if (this.id_role == 4) {
        this.$router.push({
          name: 'eadInstrutor',
          params: {
            'ini': ini_date.getTime(),
            'end': end_date.getTime(),
            'turma': turma.id_turma_teorica
          }
        })
      }
    },
    biometria(idTurma) {
      let self = this
      self.$http
        .get(urlApi + `/getran/atualizar/turma/${idTurma}/biometria`)
        .then(function (response) {
          TurmasController.launchToast(
            'fa-check',
            response.data.dados,
            'top-center'
          )
        })
        .catch(function (error) {
          self.table.load = false
          TurmasController.launchToast(
            'fa-times',
            error.data.dados,
            'top-center'
          )
        })
    },
    faces(idTurma) {
      let self = this
      self.$http
        .get(urlApi + `/getran/atualizar/turma/${idTurma}/faces`)
        .then(function (response) {
          TurmasController.launchToast(
            'fa-check',
            response.data.dados,
            'top-center'
          )
        })
        .catch(function (error) {
          self.table.load = false
          TurmasController.launchToast(
            'fa-times',
            error.data.dados,
            'top-center'
          )
        })
    },
    ativar(opcao) {
      if (opcao == 'Alunos Regulares') {
        this.regular = true
      } else if (opcao == 'Alunos Reposição') {
        this.reposicao = true
      } else if (opcao == 'Aulas') {
        this.aula = true
      } else if ('Presenças') {
        this.historico = true
      }

      if (opcao == 'Feedback') {
        this.feedback = true
      }
    },
    registrarPresenca(turma) {
      this.loadingButton = true
      var ini = turma.data_inicio.split(/[- :]/)
      var end = turma.data_fim.split(/[- :]/)

      var ini_date = new Date(new Date(ini[0], ini[1] - 1, ini[2], ini[3], ini[4], ini[5]).getTime() - 30 * 60000)
      var end_date = new Date(new Date(end[0], end[1] - 1, end[2], end[3], end[4], end[5]).getTime() + 60 * 60000)
      var tolerancia = new Date(new Date(ini[0], ini[1] - 1, ini[2], ini[3], ini[4], ini[5]).getTime() + 15 * 60000)
      let now = new Date()
      let localTime = now.getTime()
      let localOffset = now.getTimezoneOffset() * 60000
      let utc = localTime + localOffset
      let offset = -3
      let fortaleza = utc + (3600000 * offset)
      let nowUtc = new Date(fortaleza)
      if (now.getTime() != nowUtc.getTime()) {
        console.log('HORA LOCAL: ' + now)
        console.log('HORA DE FORTALEZA: ' + nowUtc)
        now = nowUtc
      }

      if (ini_date > now || end_date < now) {
        PresencaController.launchToast('fa-times', 'Essa aula não está disponível!')

        setTimeout(() => {
          this.loadingButton = false
        }, 2000)
      } else {
        var presencaLogin
        if (tolerancia < now) {
          this.$http.get(urlApi + '/turmas/presenca/aluno/' + turma.id_turma_teorica).then((response) => {
            presencaLogin = response.body.dados
            if (presencaLogin === true) {
              var saida = new Date(new Date(end_date).getTime() - (60 * 60000))
              this.turma = turma
              this.$http.get(urlApi + '/ead/intervalo/' + turma.id_turma_teorica).then((response) => {
                console.log(response.body.intervalo)
                if (response.body.intervalo) {
                  const agora = new Date()
                  const intervalo_inicio = new Date(response.body.intervalo.inicio)
                  const intervalo_fim = new Date(response.body.intervalo.fim)
                  if (agora >= intervalo_inicio && agora <= intervalo_fim) {
                    this.processPhoto()
                  } else {
                    if (now > saida) {
                      this.processPhoto()
                    } else {
                      let button = document.getElementById('push_' + this.turma.id_agrupamento)
                      button.title = 'Entrar na sala!'
                      button.disabled = false
                    }
                  }
                } else {
                  if (now > saida) {
                    this.processPhoto()
                  } else {
                    console.log(now + ' > ' + saida)
                    this.turma = turma
                    let button = document.getElementById('push_' + this.turma.id_agrupamento)
                    button.title = 'Entrar na sala!'
                    button.disabled = false
                  }
                }
              })
            } else {
              PresencaController.launchToast('fa-times', 'Essa aula não está disponível!')
            }
          }).catch((erro) => {
            if (erro.body.dados === false) {
              PresencaController.launchToast('fa-times', 'Você está atrasado para esta aula! Contate sua AutoEscola!')
            } else if (erro.body.dados === null) {
              PresencaController.launchToast('fa-times', 'ERRO: ' + erro.body.mensagem)
              console.log(erro.body.mensagem)
            }
          })
        } else {
          this.turma = turma
          this.processPhoto()
        }

        setTimeout(() => {
          this.loadingButton = false
        }, 2000)
      }
    },
    processPhoto() {
      let self = this
      self.presenca = false
      navigator.mediaDevices.getUserMedia({ video: { width: 250, height: 250 } })
        .then(function (stream) {
          self.stream = stream
          document.getElementById('player').srcObject = stream
          self.$refs.photoModal.open()
        }).catch(function (err) {
          if (err.name == 'AbortError') {
            // declarações para manipular exceções AbortError
            PresencaController.launchToast('fa-times', err)
            PresencaController.launchToast('fa-times', 'Operação Interrompida!'.toUpperCase())
          } else if (err.name == 'NotAllowedError') {
            // declarações para manipular exceções NotAllowedError
            PresencaController.launchToast('fa-times', err)
            PresencaController.launchToast('fa-times', 'Não foi possível acessar sua câmera! Cheque as permissões do sistema.'.toUpperCase())
          } else if (err.name == 'NotFoundError') {
            // declarações para manipular exceções NotFoundError
            PresencaController.launchToast('fa-times', err)
            PresencaController.launchToast('fa-times', 'Nenhuma câmera encontrada!'.toUpperCase())
          } else if (err.name == 'NotReadableError') {
            // declarações para manipular exceções NotReadableError
            PresencaController.launchToast('fa-times', err)
            PresencaController.launchToast('fa-times', 'Não foi possível acessar sua câmera!'.toUpperCase())
          } else if (err.name == 'OverconstrainedError') {
            // declarações para manipular exceções OverconstrainedError
            PresencaController.launchToast('fa-times', err)
            PresencaController.launchToast('fa-times', 'Dispositivo inválido!'.toUpperCase())
          } else if (err.name == 'SecurityError') {
            // declarações para manipular exceções SecurityError
            PresencaController.launchToast('fa-times', err)
            PresencaController.launchToast('fa-times', 'O sistema não possui permissão para acessar sua câmera! Cheque as permissões do sistema.'.toUpperCase())
          } else if (err.name == 'TypeError') {
            // declarações para manipular exceções TypeError
            PresencaController.launchToast('fa-times', err)
            PresencaController.launchToast('fa-times', 'Erro desconhecido!'.toUpperCase())
          } else {
            // declarações para manipular quaisquer exceções não especificadas
            PresencaController.launchToast('fa-times', err)
            PresencaController.launchToast('fa-times', 'Erro desconhecido!'.toUpperCase())
          }

          console.log(err)
        })
    },
    captureSnapshot() {
      let self = this

      var snapshotCanvas = document.getElementById('snapshot')
      snapshotCanvas
        .getContext('2d')
        .drawImage(document.getElementById('player'), 0, 0, 250, 250)
      document.getElementById('send').disabled = false
    },
    sendSnapshot() {
      let self = this

      self.$refs.photoModal.close()

      var data = {
        foto: document.getElementById('snapshot').toDataURL('image/jpeg'),
        cpf: localStorage.cpf
      }

      PresencaController.sendSnapshot(data, function (response) {
        var size = response.data.dados[1]
        var conf = response.data.dados[2]

        console.log('Confiança: ' + conf ** 2 / size)

        if ((conf ** 2 / size) > 70) {
          PresencaController.launchToast('fa-times', 'Foto inválida!')
          self.$refs.photoModal.open()
        } else {
          let role = ''

          if (self.id_role == 4) {
            role = 'ALUNO'
          } else if (self.id_role == 3) {
            role = 'INSTRUTOR'
          }

          let data = {
            entidade: role,
            id: localStorage.id,
            turma: self.turma.id_turma_teorica,
            dispositivo: 'navegador'

          }

          self.$http.post(urlApi + '/ead/presenca', data).then(function (response) {
            console.log()
            PresencaController.launchToast('fa-check', 'Sucesso!')

            let button = document.getElementById('push_' + self.turma.id_agrupamento)
            button.title = 'Entrar na sala!'
            button.disabled = false
            self.modalClosed()
          }).catch(function (error) {
            console.log(error.body.mensagem)
            PresencaController.launchToast('fa-check', error.body.mensagem)
            console.log(error)
          })
        }
      })
    },
    push(dados) {
      let instrutor = this.id_role == 3
      let data = {
        sala: dados.id_agrupamento, instrutor: instrutor, nome: localStorage.nome, id_aluno: localStorage.id, turma_teorica: dados.id_turma_teorica
      }
      this.$http.post(urlApi + '/ead/meet', data)
        .then(response => {
          console.log(response.body.link)
          let agrupamento = {
            agrupamento: dados.id_agrupamento,
            instrutor: instrutor
          }
          window.sessionStorage['agrupamento'] = JSON.stringify(agrupamento)
          window.sessionStorage['intervalo'] = false
          window.sessionStorage['saida'] = false
          router.push({ path: '/ead/' + btoa(btoa(response.body.link)) })
        })
        .catch((err) => {
          console.log(err)
          PresencaController.launchToast('fa-times', 'Ocorreu um erro ao tentar acessar a aula, aguarde alguns minutos e tente novamente.')
        })
    },
    modalClosed(eventClose) {
      this.stream.getTracks().forEach(function (track) {
        track.stop()
      })
    },
    atualizarTurmas() {
      let self = this
      let data = document.getElementById('data').value
      if (!data) {
        TurmasController.launchToast('fa-times', 'Nenhuma data selecionada!')
      }
      self.table.load = true
      self.$http
        .get(urlApi + `/getran/atualizar/turmas/${data}`)
        .then(function (response) {
          self.table.data = response.data.dados
          self.table.load = false
        })
        .catch(function (error) {
          self.table.load = false
          TurmasController.launchToast(
            'fa-times',
            error.data.dados,
            'top-center'
          )
        })
    },
    debounceInput: _.debounce(function (e) {
      this.search = e.target.value
      this.loadData()
    }, 1000),
    atualizaStatus: function (idTurma, status) {
      let self = this
      TurmasController.atualizaStatus(idTurma, status, function () {
        self.loadData()
      })
    },
    paginaEdicao(idTurma) {
      TurmasController.paginaEdicao(idTurma)
    },
    paginaAula(idTurma) {
      TurmasController.pageAdicionarAulaTeorica(idTurma)
    },
    posicao(index) {
      let distancia = index - this.table.currentPage
      console.log(distancia)
      if (distancia > -3 && distancia < 1) {
        return true
      }
      return false
    },
    cancelarTurma(idTurma) {
      self = this
      self.$http.get(urlApi + `/turmas/cancelar/${idTurma}`).then(function (response) {
        TurmasController.launchToast(
          'fa-check',
          'Sucesso',
          'top-center'
        )
        self.loadData()
      }).catch(function (error) {
        TurmasController.launchToast(
          'fa-times',
          error.data.dados,
          'top-center'
        )
      })
    },
    enviarBiometriaVirtual(turma) {
      // this.btnSendTurma = false,
      console.log(turma)
      // this.$http.post(urlApi + '/turmas/send/biometria/virtual', turma).then(response => {
      //   this.$toasted.show(response.data.mensagem, {
      //     icon: 'fa-times',
      //     position: 'top-left',
      //     duration: 10000,
      //     fullWidth: false
      //   })
      //   this.btnSendTurma = true;
      // }).catch(response => {
      //   this.$toasted.show(response.data.mensagem, {
      //     icon: 'fa-times',
      //     position: 'top-left',
      //     duration: 10000,
      //     fullWidth: false
      //   })
      //   this.btnSendTurma = true;
      // });
    },
    getStatus(turma) {
      this.btnGetStatus = false,
        console.log(turma)
      this.$http.post(urlApi + '/turmas/get/status', turma).then(response => {
        this.$toasted.show(response.data.mensagem + ', Consulte a turma novamente para atualizar os status.', {
          icon: 'fa-times',
          position: 'top-left',
          duration: 10000,
          fullWidth: false
        })
        this.btnGetStatus = true
      }).catch(response => {
        this.$toasted.show(response.data.mensagem, {
          icon: 'fa-times',
          position: 'top-left',
          duration: 10000,
          fullWidth: false
        })
        this.btnGetStatus = true
      })
    }
  }
}
</script>

<style type="scss" scoped>
.table thead tr {
  border-bottom: 0;
}

.buttons-td {
  display: flex;
  gap: 0.25rem;
  flex-wrap: wrap;
}

.action-button {
  all: unset;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .fa {
    width: 35px;
    height: 35px;
    line-height: 15px;
    margin: 0px;
    padding: 10px;
    border-radius: 50%;
    color: white;
    box-shadow: black;
  }

  .fa-info {
    background-color: #ffc20e;
    border-color: #ffc20e;
  }

  .fa-video-camera {
    color: white;
    background-color: #4ab2e3;
    border-color: #4ab2e3;
  }

  .fa-user {
    background-color: #20c997;
    border-color: #20c997;
  }

  &:not(:disabled) {
    .fa-info:hover {
      background-color: #ffc30eaa;
    }

    .fa-video-camera:hover {
      background-color: #4ab3e377;
    }

    .fa-user:hover {
      background-color: #20c9967e;
    }
  }
}

.tb-opcoes {
  display: block;
  position: absolute;
  right: 20px;
  margin-top: -8px;
}

.tb-linha:hover .tb-opcoes {
  display: block;
}

@media (max-width: 1200px) {
  .tb-opcoes {
    display: block;
  }
}

.presenca {
  margin-left: 5px;
}

.circle {
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 50%;
  display: inline-block;
}
</style>
